import React, { Fragment } from 'react';
import { GehaLogoTitle } from './GehaLogoTitle';
import { GehaLogoText } from './GehaLogoText';

export const GehaLogo = (props: object) => {
  return (
    <Fragment>
      <GehaLogoTitle
        props={props}
        style={{
          maxHeight: '36px',
          maxWidth: 'fit-content',
          width: '100%',
        }}
      />
      <GehaLogoText
        props={props}
        style={{
          marginLeft: '8px',
          maxHeight: '36px',
          maxWidth: 'fit-content',
          width: '100%',
        }}
      />
    </Fragment>
  );
};
